import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
// import Loader from "./elements/Loader"
import { SkeletonLoader } from "./Skeleton"
import NoResults from "./NoResults"

export function CategoryBody({ loading, foundProducts }) {
    return (foundProducts ? (
            <>
            <SelectedFilters />
            {/* <Toolbar /> */}
            <Products />
            <BottomToolbar />
            </> 
        ) : loading ? (
            <SkeletonLoader />
        ) : <NoResults />
    )
}

export function CategoryBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <SelectedFilters />
            {/* <Toolbar /> */}
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("category", CategoryBodyInfiniteScroll)
export default wrapContent("category", CategoryBody)
